module.exports = __webpack_public_path__ + "img/banner.562e8f59.jpeg";